// extracted by mini-css-extract-plugin
export default {"Modal":"signup_Modal__UNNh0","rounded":"signup_rounded__ugucn"};